import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageUtils {
  public safeGetSessionItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      throw new Error(`Falha ao obter item da sessionStorage: ${error}`);
    }
  }

  public safeSetSessionItem(key: string, value: string): void {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      throw new Error(`Falha ao gravar item na sessionStorage: ${error}`);
    }
  }

  public safeRemoveSessionItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      throw new Error(`Falha ao remover item da sessionStorage: ${error}`);
    }
  }
}
